/* src/app/views/contract/contract-edit.component.css */
.page-title {
  font-size: 26px;
  font-weight: 600;
  color: #00095b;
  margin: 4px 0 14px;
  letter-spacing: -0.2px;
  line-height: 1.3;
}
.filtro {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  display: block;
  margin-bottom: 5px;
  line-height: 1.4;
}
.char-counter {
  font-size: 12px;
  color: #6b7280;
  margin-top: 6px;
  line-height: 1.3;
}
.edit-section-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 16px;
}
.client-data-message {
  display: block;
  margin-top: 6px;
}
.contract-edit-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 2px solid #e5e7eb;
}
.contract-edit-actions .p-button,
.contract-edit-actions button[pbutton] {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
}
.contract-edit-disabled-reason {
  flex: 1 1 100%;
  margin: 0 0 10px;
  animation: contractEditDisabledReasonEnter 220ms ease-out;
}
.contract-edit-disabled-reason .p-message {
  width: 100%;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #f59e0b;
  border-left: 4px solid #d97706;
  background: #fffbeb;
  color: #92400e;
}
.contract-edit-disabled-reason .p-message .p-message-icon {
  font-size: 15px;
  color: #b45309;
}
.contract-edit-disabled-reason .p-message .p-message-text {
  font-weight: 600;
}
@keyframes contractEditDisabledReasonEnter {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .contract-edit-disabled-reason {
    animation: none;
  }
}
@media only screen and (max-width: 768px) {
  .page-title {
    font-size: 22px;
  }
  .contract-edit-actions {
    justify-content: flex-end;
    gap: 8px;
  }
  .contract-edit-actions .p-button,
  .contract-edit-actions button[pbutton] {
    min-height: 40px;
    padding: 0 14px;
  }
}
@media only screen and (max-width: 500px) {
  .page-title {
    font-size: 20px;
  }
  .contract-edit-actions {
    justify-content: stretch;
    flex-direction: column-reverse;
  }
  .contract-edit-actions .p-button,
  .contract-edit-actions button[pbutton] {
    width: 100%;
    justify-content: center;
  }
}
/*# sourceMappingURL=contract-edit.component-CLKAVGEE.css.map */
